import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { ActivatedRoute, ParamMap, Params, Router } from '@angular/router';
import { QarepaBaseSubsDirective } from '@qarepa/common';
import { CheckRequestStatusEnum } from '@qaroni-app/check/types/check-request-status.enum';
import { ScheduleRequestsService } from '@qaroni-app/schedule/services/schedule-requests.service';
import { RequestSummariesCount } from '@qaroni-app/schedule/types/request-summaries-count';
import { qaroniAnimations } from '@qaroni-shared/animations/qaroni-animations';
import { format, parseISO } from 'date-fns';

@Component({
  selector: 'qaroni-pending-check-request-widget',
  templateUrl: './pending-check-request-widget.component.html',
  styleUrl: './pending-check-request-widget.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [qaroniAnimations.enterFadeIn()],
  standalone: false,
})
export class PendingCheckRequestWidgetComponent
  extends QarepaBaseSubsDirective
  implements OnInit
{
  private scheduleRequestsService = inject(ScheduleRequestsService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  public $counter = signal(0);
  private companyID = 0;

  private counter$ = this.scheduleRequestsService.getCounterSubject$();
  private paramMap$ = this.route.paramMap;

  ngOnInit(): void {
    this.subs.add(this.paramMap$.subscribe(this.getParamMaps));
    this.subs.add(this.counter$.subscribe(this.getCounterRequest));
  }

  get yearMonth(): string {
    const currentDate = parseISO(new Date().toISOString());
    return format(currentDate, 'yyyy-MM');
  }

  get pluralMapping() {
    return {
      '=1': $localize`Solicitud de Fichaje`,
      other: $localize`Solicitudes de Fichaje`,
    };
  }

  get hasRequests() {
    return this.$counter() > 0;
  }

  public goToCheckRequests() {
    const queryParams: Params = {
      yearMonth: this.yearMonth,
      status: CheckRequestStatusEnum.PENDING,
    };

    this.router.navigate(
      ['/companies', this.companyID, 'schedules', 'requests'],
      { queryParams }
    );
  }

  private getCounterRequest = (counter: RequestSummariesCount | null): void => {
    if (!counter) {
      this.$counter.set(0);
      return;
    }

    this.$counter.set(counter.pendingCount);
  };

  private getParamMaps = (params: ParamMap): void => {
    const paramCompanyID = params.get('companyID');

    if (paramCompanyID) {
      this.companyID = Number(paramCompanyID);

      this.scheduleRequestsService.counter(this.companyID);
    }
  };
}
